/** Session tab scope for platform admins (`GET /api/v1/dispensaries/:id` + socket). */
export const ADMIN_SCOPE_STORAGE_KEY = "thedrop:dispensary-web:adminDispensaryScope";

export function readAdminDispensaryScope(): string | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const v = sessionStorage.getItem(ADMIN_SCOPE_STORAGE_KEY);
    return v != null && v.trim().length > 0 ? v.trim() : null;
  } catch {
    return null;
  }
}

export function writeAdminDispensaryScope(id: string): void {
  try {
    sessionStorage.setItem(ADMIN_SCOPE_STORAGE_KEY, id.trim());
  } catch {
    /* ignore */
  }
}

export function clearAdminDispensaryScope(): void {
  try {
    sessionStorage.removeItem(ADMIN_SCOPE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
